/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Nav_R_Security_DInputs */

const en_mk_nav_r_security_d = /** @type {(inputs: Mk_Nav_R_Security_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What is running today, and what is not.`)
};

const id_mk_nav_r_security_d = /** @type {(inputs: Mk_Nav_R_Security_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apa yang sudah berjalan, dan apa yang belum.`)
};

/**
* | output |
* | --- |
* | "What is running today, and what is not." |
*
* @param {Mk_Nav_R_Security_DInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_nav_r_security_d = /** @type {((inputs?: Mk_Nav_R_Security_DInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Nav_R_Security_DInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_nav_r_security_d(inputs)
	return en_mk_nav_r_security_d(inputs)
});